export const REGION_IDS = [
  {
    id: 9,
    name: 'Blekinge län',
  },
  {
    id: 25,
    name: 'Dalarnas län',
  },
  {
    id: 8,
    name: 'Gotlands län',
  },
  {
    id: 19,
    name: 'Gävleborgs län',
  },
  {
    id: 11,
    name: 'Hallands län',
  },
  {
    id: 21,
    name: 'Jämtlands län',
  },
  {
    id: 5,
    name: 'Jönköpings län',
  },
  {
    id: 7,
    name: 'Kalmar län',
  },
  {
    id: 6,
    name: 'Kronobergs län',
  },
  {
    id: 23,
    name: 'Norrbottens län',
  },
  {
    id: 10,
    name: 'Skåne län',
  },
  {
    id: 1,
    name: 'Stockholms län',
  },
  {
    id: 3,
    name: 'Södermanlands län',
  },
  {
    id: 2,
    name: 'Uppsala län',
  },
  {
    id: 15,
    name: 'Värmlands län',
  },
  {
    id: 22,
    name: 'Västerbottens län',
  },
  {
    id: 20,
    name: 'Västernorrlands län',
  },
  {
    id: 17,
    name: 'Västmanlands län',
  },
  {
    id: 26,
    name: 'Västra Götalands län',
  },
  {
    id: 16,
    name: 'Örebro län',
  },
  {
    id: 4,
    name: 'Östergötlands län',
  },
];

// Norwegian fylker (ids 36-50), shown when a cottage's country is NO.
// Mirrors regionsList ids in the API (src/constants/index.js).
export const FYLKE_IDS = [
  { id: 43, name: 'Agder' },
  { id: 37, name: 'Akershus' },
  { id: 39, name: 'Buskerud' },
  { id: 50, name: 'Finnmark' },
  { id: 40, name: 'Innlandet' },
  { id: 46, name: 'Møre og Romsdal' },
  { id: 48, name: 'Nordland' },
  { id: 36, name: 'Oslo' },
  { id: 44, name: 'Rogaland' },
  { id: 42, name: 'Telemark' },
  { id: 49, name: 'Troms' },
  { id: 47, name: 'Trøndelag' },
  { id: 45, name: 'Vestland' },
  { id: 41, name: 'Vestfold' },
  { id: 38, name: 'Østfold' },
];
